// extracted by mini-css-extract-plugin
export var anchorWrapper = "cardSection-module--anchorWrapper--9bab0";
export var anchortext = "cardSection-module--anchortext--16f78";
export var buttonLabel = "cardSection-module--buttonLabel--ae9e9";
export var buttonRoot = "cardSection-module--buttonRoot--da22a";
export var description = "cardSection-module--description--eb28d";
export var entryLink = "cardSection-module--entryLink--cb81f";
export var faqHeading = "cardSection-module--faqHeading--67f16";
export var gridInner = "cardSection-module--gridInner--be70b";
export var gridRoot = "cardSection-module--gridRoot--d7180";
export var heading3 = "cardSection-module--heading3--6d855";
export var iconWrapper = "cardSection-module--iconWrapper--5eeb9";
export var internalLink = "cardSection-module--internalLink--47112";
export var paper = "cardSection-module--paper--c31d1";
export var paragraph = "cardSection-module--paragraph--cc15a";
export var recentClientNewsHeader = "cardSection-module--recentClientNewsHeader--4d1c0";
export var recentClientNewsSubHeader = "cardSection-module--recentClientNewsSubHeader--36700";
export var showHoverShadow = "cardSection-module--showHoverShadow--55d5c";
export var stack = "cardSection-module--stack--f7388";
export var title = "cardSection-module--title--0b66d";